import Show from '../show'

function ApliDashboard() {
  return (
    <Show
      title="Accounts Payable Line Item Dashboard"
      dashboardKey="apli_dashboards"
      sectionAbbreviation="APLI"
      showYear={false}
    />
  )
}

export default ApliDashboard
